import { useState } from 'react';
import './MailingListModal.css';

function MailingListModal({ isOpen, onClose }) {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [interests, setInterests] = useState([]);
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  const interestOptions = [
    { id: 'events', label: 'Community Events' },
    { id: 'volunteer', label: 'Volunteer Opportunities' },
    { id: 'safety', label: 'Safety Updates' },
    { id: 'development', label: 'Neighborhood Development' }
  ];

  const handleInterestChange = (interestId) => {
    setInterests(prev =>
      prev.includes(interestId)
        ? prev.filter(id => id !== interestId)
        : [...prev, interestId]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    try {
      const response = await fetch('/api/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          firstName: firstName.trim() || undefined,
          interests: interests.length > 0 ? interests : undefined
        })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setStatus('success');
        setMessage(data.message);
        // Reset form after success
        setEmail('');
        setFirstName('');
        setInterests([]);
      } else {
        setStatus('error');
        setMessage(data.error || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Unable to connect. Please check your internet connection.');
    }
  };

  const handleClose = () => {
    // Reset state when closing
    if (status === 'success') {
      setStatus('idle');
      setMessage('');
    }
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="mailing-modal-overlay" onClick={handleClose}>
      <div className="mailing-modal" onClick={e => e.stopPropagation()}>
        <button className="mailing-modal-close" onClick={handleClose}>
          &times;
        </button>

        {status === 'success' ? (
          <div className="mailing-success">
            <div className="mailing-success-icon">&#10003;</div>
            <h2>You're In!</h2>
            <p>{message}</p>
            <button className="mailing-submit-btn" onClick={handleClose}>
              Done
            </button>
          </div>
        ) : (
          <>
            <h2 className="mailing-title">Join Our Mailing List</h2>
            <p className="mailing-subtitle">
              Stay connected with EaDo Civic. Get updates on community events,
              volunteer opportunities, and neighborhood news.
            </p>

            <form onSubmit={handleSubmit} className="mailing-form">
              <div className="mailing-field">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  disabled={status === 'loading'}
                />
              </div>

              <div className="mailing-field">
                <label htmlFor="firstName">First Name (optional)</label>
                <input
                  type="text"
                  id="firstName"
                  value={firstName}
                  onChange={e => setFirstName(e.target.value)}
                  placeholder="Your first name"
                  disabled={status === 'loading'}
                />
              </div>

              <div className="mailing-field">
                <label>I'm interested in: (optional)</label>
                <div className="mailing-interests">
                  {interestOptions.map(option => (
                    <label key={option.id} className="mailing-interest-option">
                      <input
                        type="checkbox"
                        checked={interests.includes(option.id)}
                        onChange={() => handleInterestChange(option.id)}
                        disabled={status === 'loading'}
                      />
                      <span>{option.label}</span>
                    </label>
                  ))}
                </div>
              </div>

              {status === 'error' && (
                <div className="mailing-error">{message}</div>
              )}

              <button
                type="submit"
                className="mailing-submit-btn"
                disabled={status === 'loading'}
              >
                {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
              </button>

              <p className="mailing-privacy">
                We respect your privacy. Unsubscribe anytime.
              </p>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default MailingListModal;
